// כרטיס קמפיין עם תמונה חיה של הבאנר (אותו runtime של היצוא) — משמש בבית ובמסך הקמפיינים.
import { Link } from 'react-router-dom';
import Icon from './Icon';
import VariantThumb, { useVariantCtx } from './editor/VariantThumb';
import { CAMPAIGN_STATUS } from './mgmt/common';

export interface CampaignRow {
  id: string; name: string; status: string; updated_at: string; client_name: string;
  cover_variant_id?: string | null; variant_count?: number;
}

function Cover({ id }: { id: string }) {
  const { ctx } = useVariantCtx(id);
  return <VariantThumb ctx={ctx} maxW={280} maxH={140} />;
}

export function relTime(s: string) {
  const d = (Date.now() - new Date(s).getTime()) / 1000;
  if (d < 90) return 'לפני רגע';
  if (d < 3600) return `לפני ${Math.round(d / 60)} דקות`;
  if (d < 86400) return `לפני ${Math.round(d / 3600)} שעות`;
  if (d < 86400 * 7) return `לפני ${Math.round(d / 86400)} ימים`;
  return new Date(s).toLocaleDateString('he-IL');
}

export default function CampaignCard({ c }: { c: CampaignRow }) {
  const st = c.status === 'active' ? 'ok' : c.status === 'draft' ? 'warn' : '';
  return (
    <Link to={`/campaigns/${c.id}`} className="camp-card">
      <div className="cover">
        {c.cover_variant_id ? <Cover id={c.cover_variant_id} /> : <span className="ph"><Icon name="image" size={28} /><br />עדיין בלי באנרים</span>}
      </div>
      <div className="meta">
        <strong>{c.name}</strong>
        <span>{c.client_name}</span>
        <span className="row" style={{ justifyContent: 'space-between', marginTop: 6 }}>
          <span className={`badge ${st}`}>{CAMPAIGN_STATUS[c.status] ?? c.status}</span>
          <span>{c.variant_count ? `${c.variant_count} גדלים · ` : ''}{relTime(c.updated_at)}</span>
        </span>
      </div>
    </Link>
  );
}
